(function () {
  function loadMap(container) {
    if (container.dataset.loaded === 'true') return;

    var mapLink = container.dataset.mapLink || '';
    var template = container.querySelector('[data-event-map-html]');
    var mapHtml = template ? template.innerHTML : '';
    var placeholder = container.querySelector('.event-product-store__map-placeholder');

    if (mapLink) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute('title', container.dataset.mapTitle || 'Store location map');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('allowfullscreen', '');
      iframe.src = mapLink;
      container.replaceChildren(iframe);
      container.dataset.loaded = 'true';
      return;
    }

    if (mapHtml) {
      container.innerHTML = mapHtml;
      container.dataset.loaded = 'true';
      return;
    }

    if (placeholder) {
      placeholder.hidden = false;
    }
  }

  function initContainer(container) {
    var mapLink = container.dataset.mapLink || '';
    var template = container.querySelector('[data-event-map-html]');
    var hasHtml = Boolean(template && template.innerHTML.trim());
    var placeholderButton = container.querySelector('[data-event-map-load]');

    if (placeholderButton) {
      placeholderButton.addEventListener('click', function () {
        loadMap(container);
      });
    }

    if (mapLink) {
      return;
    }

    if (!hasHtml) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      loadMap(container);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadMap(container);
          observer.disconnect();
        });
      },
      { rootMargin: '120px' }
    );

    observer.observe(container);
  }

  function init() {
    document.querySelectorAll('[data-event-product-map]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
